import React from "react";
import { Row, Col } from "reactstrap";
// import STYLES from '../STYLES';
import GeneralForm from "./GeneralForm";

export class GeneralContent extends React.Component {
    render() {
        return (
            <div>
                <Row>
                    <Col xs="12" style={{ margin: "10px auto", fontSize: 12 }}>
                        <h5
                            style={{
                                marginTop: 5,
                                marginBottom: 10,
                                textAlign: "center"
                            }}
                        >
                            {"General Information"}
                        </h5>
                        <GeneralForm />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default GeneralContent;
